// Overrides the Shopify-native product count in the collection toolbar
// with the actual number of cards rendered in the ReQaf grid.
// Runs on initial load and after Dawn's facets.js AJAX swap (via MutationObserver).
(function () {
  function applyRenderedCount() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var count = grid.querySelectorAll('.reqaf-collection-grid__item').length;
    var label = count === 1 ? 'product' : 'products';
    var text = count + ' ' + label;
    document.querySelectorAll('#ProductCountDesktop, #ProductCount, .mobile-facets__count').forEach(function (el) {
      el.textContent = text;
    });
  }

  function init() {
    applyRenderedCount();
    var container = document.getElementById('ProductGridContainer');
    if (!container || container.dataset.reqafCountObserver) return;
    container.dataset.reqafCountObserver = '1';
    new MutationObserver(applyRenderedCount).observe(container, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
